import { type FC } from 'react';
import { numberWithCommas } from 'helpers/TextHelpers';
import { PackRarity } from 'global/constants';
import { type PackProps } from './types';
import { getPackInfo } from './helpers';
import PackImage from './PackImage';
import PackCounter from './PackCounter';
import {
  PackContainer,
  PackDescription,
  PackTitle,
  PackPrice,
  PackImageWrapper,
} from './styled';

const Pack: FC<PackProps> = ({
  packType = PackRarity.common,
  price,
  currency,
  isSaleFinished,
  isSaleStarted,
  packsCount,
  packsLeft,
  packsSold,
  children,
  creator = '',
  title = '',
  isWithBackground = false,
  isExpected = false,
  packDistribution,
  rarity,
  'data-test-id': dataTestId,
}) => {
  let packTitle = packType.slice(-5) === '_plus' ? 'reward' : packType;
  const isSinglePack = packDistribution?.rarities.length === 1 || packType === 'mystery';
  if (isSinglePack) {
    packTitle += ' pack';
  }
  return (
    <PackContainer
      isWithBackground={isWithBackground}
      singlePack={isSinglePack}
      data-test-id={dataTestId}
    >
      <PackImageWrapper data-test-id={`image_${rarity}`} singlePack={isSinglePack}>
        <PackImage
          data-test-id="pack_image"
          creator={creator}
          title={title}
          type={packType}
          isWithBackground={isWithBackground}
        />
      </PackImageWrapper>
      <PackDescription data-test-id="pack_description" isExpected={isExpected} singlePack={isSinglePack}>
        <PackTitle
          data-test-id="pack_title"
          lSpacing={1}
          textColor="white"
          size="title"
          bold
          uppercase
        >
          {packTitle}
        </PackTitle>
        {getPackInfo(packType, packDistribution)}
        {!isSaleFinished && (
          <>
            <PackPrice data-test-id="pack_price" textColor="white" size="title" bold uppercase>
              {currency === 'FLOW' && `${numberWithCommas(+price.toFixed(2))} FLOW`}
              {currency === 'FUSD' && `$${numberWithCommas(+price.toFixed(2))}`}
            </PackPrice>
            <PackCounter
              isSaleFinished={isSaleFinished}
              isSaleStarted={isSaleStarted}
              packsCount={packsCount}
              packsLeft={packsLeft}
              packsSold={packsSold}
            />
          </>
        )}
        {isSinglePack && children}
      </PackDescription>
      {!isSinglePack && children}
    </PackContainer>
  );
};

export default Pack;
